import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('UGC_EDITOR', {
  OPEN_EDITOR: null,
  CLOSE_EDITOR: null
});
